import Styled from "styled-components";

const textPrimary = (props) =>
  props.theme.whitelabel?.theme?.text_primary_color || "#1D1D1F";
// O text_secondary_color do whitelabel (no Safra) é claro demais para fundo branco
// (foi feito p/ o header escuro). Para o texto "muted" usamos a cor de marca escura
// (text_primary_color) com opacidade — fica visível e adapta por marca.
const textSecondary = textPrimary;

/* 1 - Título da página */
export const PageTitle = Styled.h1`
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0;
  color: ${textPrimary};
  margin: 16px 0 12px;
  @media (min-width: 1024px) {
    margin: 24px 0 16px;
  }
`;

/* 2 / 7 - Cabeçalho dos dropdowns (Dados pessoais / Endereço de entrega) */
export const AccordionHeader = Styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: none;
  border: none;
  padding: 16px 0 8px;
`;

export const AccordionLabel = Styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0;
  color: ${textSecondary};
  opacity: 0.6;

  svg {
    width: 18px;
    height: 18px;
    color: ${textSecondary};
    stroke: currentColor;
  }
`;

export const Chevron = Styled.span`
  display: inline-flex;
  svg {
    width: 18px;
    height: 18px;
    color: #595959;
  }
`;

export const AccordionContent = Styled.div`
  padding: 4px 0 8px;
`;

/* 3 / 4 / 5 / 8 - Textos de dados pessoais e endereço */
export const DataText = Styled.p`
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0;
  color: ${textPrimary};
  margin: 0;
`;

/* 9 - Botão "Alterar" */
export const AlterLink = Styled.a`
  display: inline-block;
  margin-top: 8px;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0;
  color: ${textSecondary};
  opacity: 0.6;
  text-decoration: underline;
  cursor: pointer;
`;

/* 6 - Divisor */
export const Divider = Styled.div`
  border-top: 1px solid #D9D9D9;
  margin: 16px 0;
`;

/* 10 - "Produto vendido por [seller]" */
export const SellerTitle = Styled.p`
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0;
  color: ${textPrimary};
  margin: 8px 0 16px;
`;

export const ProductWrapper = Styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 16px;
`;

/* 11 - Thumb do produto 70x72 */
export const Thumb = Styled.img`
  width: 70px;
  height: 72px;
  min-width: 70px;
  object-fit: cover;
  background: #F5F5F7;
  border-radius: 4px;
`;

export const ProductInfo = Styled.div`
  flex: 1;
  min-width: 0;
`;

/* 12 - Nome do produto */
export const ProductName = Styled.p`
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0;
  color: ${textPrimary};
  margin: 0;
`;

/* 13 - Principal característica (uma linha + reticências) */
export const ProductChar = Styled.p`
  font-family: var(--font-family);
  font-size: 13px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0;
  color: #595959;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/* 14 - Valor do(s) produto(s) */
export const ProductValue = Styled.p`
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0;
  color: ${textPrimary};
  margin: 4px 0 0;
`;

/* 15 / 16 / 17 - Linhas Frete / Subtotal / Chega até (por seller) */
export const InfoRow = Styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;

  span {
    font-family: var(--font-family);
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0;
    color: ${textPrimary};
  }
  span.value {
    text-align: right;
  }
`;

/* 18 - Box de totais */
export const SummaryBoxWrap = Styled.div`
  background: #F5F5F7;
  border-radius: 8px;
  padding: 20px 16px;
  margin-top: 16px;
`;

/* 19 / 20 - Frete do pedido / Subtotal do pedido */
export const SummaryRow = Styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;

  span {
    font-family: var(--font-family);
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    letter-spacing: 0;
    color: ${textPrimary};
  }
  span.value {
    text-align: right;
  }
`;

export const BoxDivider = Styled.div`
  border-top: 1px solid #D9D9D9;
  margin: 16px 0;
`;

/* 21 - Título Cupom de desconto / Gift Card */
export const CouponTitle = Styled.p`
  font-family: var(--font-family);
  font-size: 13px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0;
  color: ${textSecondary};
  opacity: 0.6;
  margin: 0 0 8px;
`;

export const CouponRow = Styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;
`;

export const CouponInputWrap = Styled.div`
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  padding: 0 10px;

  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    padding: 9px 0;
    font-family: var(--font-family);
    font-size: 13px;
    font-weight: 400;
    line-height: 150%;
    color: ${textPrimary};

    ::placeholder {
      color: ${textPrimary};
      opacity: 0.6;
    }
  }

  .clear-btn {
    border: none;
    background: none;
    padding: 0 0 0 8px;
    display: inline-flex;
    cursor: pointer;
    color: ${textSecondary};
  }
`;

export const CouponApplyButton = Styled.button`
  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  padding: 0 18px;
  font-family: var(--font-family);
  font-size: 13px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0;
  color: ${textPrimary};
  text-transform: uppercase;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

/* Cupom - erro (item 6 da spec de cupom) */
export const CouponErrorText = Styled.p`
  font-family: var(--font-family);
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0;
  color: #F89393;
  margin: 6px 0 0;
`;

/* Cupom - sucesso/aplicado */
export const CouponSuccessBox = Styled.div`
  background: #F4FFF3;
  border-radius: 4px;
  padding: 12px;
  margin-top: 12px;

  .coupon-success-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .coupon-code {
    font-family: var(--font-family);
    font-size: 14px;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: 0;
    color: #2D8D68;
  }

  .coupon-remove {
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    color: #4F4F4F;
  }
  .coupon-remove svg {
    width: 18px;
    height: 18px;
  }

  .coupon-category {
    font-family: var(--font-family);
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0;
    color: #4F4F4F;
    margin: 4px 0;
  }

  .coupon-rules-link {
    font-family: var(--font-family);
    font-size: 12px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: 0;
    color: #4F4F4F;
    text-decoration: underline;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }
`;

/* 24 - Total do pedido */
export const TotalRow = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;

  .total-label {
    font-family: var(--font-family);
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: 0;
    text-transform: uppercase;
    color: ${textPrimary};
  }

  .total-value {
    font-family: var(--font-family);
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: 0;
    text-align: right;
    color: ${textPrimary};
  }
`;

export const EmptyWrap = Styled.div`
  text-align: center;
  padding: 40px 16px;

  p {
    font-family: var(--font-family);
    color: ${textPrimary};
  }
`;

/* ===== Desktop (>=1024px): resumo em 2 colunas ===== */
export const SummaryLayout = Styled.div`
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    gap: 32px;
    align-items: start;
    margin-top: 16px;

    .os-summary { position: sticky; top: 100px; }
    .os-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 16px;
    }
  }
`;

/* Desktop: alinha o Container do Bootstrap ao padrão do header (1320/32) */
export const PageWrap = Styled.div`
  @media (min-width: 1024px) {
    .container {
      max-width: 1320px;
      padding-left: 32px;
      padding-right: 32px;
    }
  }
`;
